// extracted by mini-css-extract-plugin
export default {"cell":"ChessCell_cell__e84nZ","black":"ChessCell_black__RU789","white":"ChessCell_white__N0N6S","selected":"ChessCell_selected__6GnWM","available":"ChessCell_available__t63RG"};